import {action, makeObservable} from "mobx";
import Feature from "../../Feature";

export default class CustomerOnboardingPanelFeature extends Feature {

    constructor(application, generalFeature) {
        super(application);
        this._generalFeature = generalFeature;

        makeObservable(this, {
            customerOnboardingHasChanged: action
        })
    }

    customerOnboarding() {
        return this._generalFeature.customerOnboarding
    }

    async customerOnboardingHasChanged() {
        await this._generalFeature.customerOnboardingHasChanged()
    }

    isComplete(){
        return this.form.mandatoryCompletionPercentage() === Math.round(100);
    }

}
